'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, Image } from '@petsmart-ui/sparky';
import { useEffect, useRef, useState } from 'react';
import { decodeEntityString } from '@libs/algolia';
import { useDecisions, useOptimizely } from '@libs/common-next';
import type { OptexSearchBiaGuestProduct } from './use-optex-search-bia-guest';
import './optex-search-bia-guest.scss';
type OptexSearchBiaGuestProps = Readonly<{
  query: string;
  products?: OptexSearchBiaGuestProduct[] | null;
}>;
const OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE = 312;
export function OptexSearchBiaGuest(t0) {
  const $ = _c(25);
  const {
    query,
    products
  } = t0;
  const isOptexSearchBiaGuestEnabled = useDecisions("search_bia_guest");
  const {
    context
  } = useOptimizely();
  const optexRailRef = useRef(null);
  const [canScrollBack, setCanScrollBack] = useState(false);
  const [canScrollForward, setCanScrollForward] = useState(false);
  const isOptexCarouselVisible = Boolean(isOptexSearchBiaGuestEnabled && query === "" && products?.length);
  let t1;
  let t2;
  if ($[0] !== context || $[1] !== isOptexCarouselVisible) {
    t1 = () => {
      if (isOptexCarouselVisible) {
        context?.trackEvent("_us_ca__carousel_impressions__fxe___global___s___1085_");
      }
    };
    t2 = [isOptexCarouselVisible, context];
    $[0] = context;
    $[1] = isOptexCarouselVisible;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const optexRail = optexRailRef.current;
      if (!optexRail) {
        return;
      }
      const updateOptexScrollControls = () => {
        setCanScrollBack(optexRail.scrollLeft > 0);
        setCanScrollForward(optexRail.scrollLeft + optexRail.clientWidth < optexRail.scrollWidth - 1);
      };
      updateOptexScrollControls();
      optexRail.addEventListener("scroll", updateOptexScrollControls);
      window.addEventListener("resize", updateOptexScrollControls);
      return () => {
        optexRail.removeEventListener("scroll", updateOptexScrollControls);
        window.removeEventListener("resize", updateOptexScrollControls);
      };
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isOptexSearchBiaGuestEnabled || $[6] !== products || $[7] !== query) {
    t4 = [products, isOptexSearchBiaGuestEnabled, query];
    $[5] = isOptexSearchBiaGuestEnabled;
    $[6] = products;
    $[7] = query;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  if (!isOptexCarouselVisible || !products) {
    return null;
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="optex-search-bia-guest__title" id="optex-search-bia-guest-title">Most-loved essentials</h2>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== context || $[11] !== products) {
    let t7;
    if ($[13] !== context) {
      t7 = (optexProduct, index) => <li className="optex-search-bia-guest__item" key={`${optexProduct.sku}-${index}`}><a className="optex-search-bia-guest__link" href={optexProduct.href} onClick={() => context?.trackEvent("_us_ca__bia_search_click_engagement__fxe___global___s___1085_")}><Image className="optex-search-bia-guest__image" src={optexProduct.imageUrl} alt="" width={96} height={96} loading="lazy" /><span className="optex-search-bia-guest__name">{decodeEntityString(optexProduct.name)}</span></a></li>;
      $[13] = context;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = products.map(t7);
    $[10] = context;
    $[11] = products;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <ul ref={optexRailRef} className="optex-search-bia-guest__rail" aria-label="Most-loved essentials products">{t6}</ul>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== canScrollBack) {
    t8 = canScrollBack && <button aria-label="Previous Most-loved essentials products" className="optex-search-bia-guest__arrow optex-search-bia-guest__arrow--back" type="button" onClick={() => optexRailRef.current?.scrollBy({
      left: -OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE,
      behavior: "smooth"
    })}><Icon name="chevron-left" /></button>;
    $[17] = canScrollBack;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== canScrollForward) {
    t9 = canScrollForward && <button aria-label="Next Most-loved essentials products" className="optex-search-bia-guest__arrow optex-search-bia-guest__arrow--forward" type="button" onClick={() => optexRailRef.current?.scrollBy({
      left: OPTEX_SEARCH_BIA_GUEST_SCROLL_DISTANCE,
      behavior: "smooth"
    })}><Icon name="chevron-right" /></button>;
    $[19] = canScrollForward;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <section className="optex-search-bia-guest" aria-labelledby="optex-search-bia-guest-title">{t5}<div className="optex-search-bia-guest__carousel">{t7}{t8}{t9}</div></section>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}